import { render, staticRenderFns } from "./stadium_photo.vue?vue&type=template&id=c88c74da&scoped=true&"
import script from "./stadium_photo.vue?vue&type=script&lang=ts&"
export * from "./stadium_photo.vue?vue&type=script&lang=ts&"
import style0 from "./stadium_photo.vue?vue&type=style&index=0&id=c88c74da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88c74da",
  null
  
)

export default component.exports